<template>
  <div
    v-if="
      ($store.state.fastPermissoes.administrador == 'S' || $store.state.fastPermissoes.secretario == 'S') &&
        $store.state.fastPermissoes.ativo == 'S' &&
        $store.state.fastPlataformaModulos.modulo_secretaria
    "
  >
    <div class="fd-app-wrap">
      <div class="container">
        <!-- breadcrumb -->
        <nav>
          <ul class="fd-app-breadcrumb">
            <li class="fd-app-breadcrumb-item">
              <a
                href="/minhas-plataformas"
                class="aluno_font_color"
                @click.prevent="$router.push('/minhas-plataformas')"
              >Minhas Plataformas</a>
            </li>
            <li class="fd-app-breadcrumb-item">
              <a
                class="aluno_font_color"
                href="#"
                @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma)"
              >Plataforma {{ $store.state.fastPlataforma.nome_plataforma }}</a>
            </li>
            <li class="fd-app-breadcrumb-item">
              <a
                v-if="getUrlParameter('tesouraria')"
                class="aluno_font_color"
                :href="
                  '/plataforma/' +
                    $route.params.id_plataforma +
                    '/tesouraria'
                "
                @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/tesouraria')"
              >Modo tesouraria</a>
              <a
                v-else
                class="aluno_font_color"
                :href="
                  '/plataforma/' +
                    $route.params.id_plataforma +
                    '/secretaria'
                "
                @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/secretaria')"
              >Modo secretaria</a>
            </li>
            <li class="fd-app-breadcrumb-item active">
              <a
                class="aluno_font_color"
                href="#"
              >Contratos</a>
            </li>
          </ul>
        </nav>

        <!-- /breadcrumb -->
      </div>
      <div class="fd-mode-adm-content mt-4">
        <div class="container">
          <div class="row">
            <div
              id="body_conteudo_modo_admin"
              class="col-sm-12 col-md-12 fd-mode-adm-content-body col-lg-12 ml-0"
            >
              <!-- fd-app-welcome -->
              <section class="fd-app-welcome text-left">
                <h1 class="aluno_font_color">
                  Templates de
                  <span>contrato</span>
                </h1>

                <img :src="require('@/assets/images/form-effect-01.png')">
              </section>
              <!-- /fd-app-welcome -->
              
              <!-- Lista de contratos -->
              <div
                v-show="!fastSecretariaContratoNovo.exibir && !fastSecretariaContratoEditar.exibir"
                class="row"
              >
                <div class="col-12 mt-2">
                  <div class="card shadow mb-4">
                    <div class="card-header py-3">
                      <div class="row">
                        <div class="col-sm-12 col-md-12 col-lg-6">
                          <h6 class="m-0 font-weight-bold text-primary">
                            Lista de contratos
                          </h6>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-6 text-right">
                          <button
                            class="btn btn-sm btn-primary"
                            @click.prevent="fastSecretariaContratoNovo.exibir = true"
                          >
                            <small>+ Criar contrato</small>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-12 table-responsive mt-2">
                          <table class="table table-sm">
                            <thead class="thead-dark">
                              <tr class="text-center">
                                <th>
                                  <small
                                    class="font-weight-bold"
                                  >Nome do contrato</small>
                                </th>
                                <th>
                                  <small
                                    class="font-weight-bold"
                                  >Tipo</small>
                                </th>
                                <th class="text-center">
                                  <small class="font-weight-bold">Ações</small>
                                </th>
                              </tr>
                            </thead>
                            <tbody v-if="fastSecretariaContratosLoading">
                              <tr>
                                <td
                                  colspan="3"
                                  class="text-center"
                                  v-html="fastLoadingDados()"
                                />
                              </tr>
                            </tbody>
                            <tbody v-else-if="fastSecretariaContratos.length">
                              <tr
                                v-for="contrato in fastSecretariaContratos"
                                :key="contrato.id_contrato"
                              >
                                <td class="align-middle text-center">
                                  <small>{{ contrato.nome_contrato }}</small>                                  
                                </td>         
                                <td class="align-middle text-center">
                                  <small v-if="contrato.tipo_contrato == 'C' && contrato.id_secretaria_curso">Certificado de curso - {{ contrato.nome_curso }}</small>
                                  <small v-else-if="contrato.tipo_contrato == 'C' && !contrato.id_secretaria_curso">Todos os cursos</small>                                  
                                </td>                           
                                <td class="text-center align-middle">                                  
                                  <button
                                    class="btn btn-sm btn-primary pt-0 pb-0 mr-2"
                                    @click="exibeModalEditarContrato(contrato)"
                                  >
                                    <small>Editar</small>
                                  </button>
                                  <button
                                    class="btn btn-sm btn-danger pt-0 pb-0 mr-2"
                                    @click="exibeModalExcluirContrato(contrato)"
                                  >
                                    <small>Excluir</small>
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                            <tbody v-else>
                              <tr>
                                <td
                                  colspan="3"
                                  class="text-center"
                                >
                                  Nenhum contrato cadastrado
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Novo contrato -->
              <div
                v-show="fastSecretariaContratoNovo.exibir"
                class="row"
              >
                <div class="col-sm-12 col-md-12 col-lg-12 mt-4 mb-4 text-center">
                  <h3>Novo contrato</h3>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-12 mt-2">
                  <label>Nome do contrato</label>
                  <input
                    v-model="fastSecretariaContratoNovo.nome_contrato"
                    type="text"
                    class="form-control"
                    maxlength="30"
                  >
                </div>
                <div class="col-sm-12 col-md-12 col-lg-12 mt-2">
                  <label>Tipo de contrato</label>
                  <select
                    v-model="fastSecretariaContratoNovo.tipo_contrato"
                    class="form-control"
                  >
                    <option value="C">
                      Curso
                    </option>
                  </select>
                </div>
                <div
                  v-if="fastSecretariaContratoNovo.tipo_contrato == 'C'"
                  class="col-sm-12 col-md-12 col-lg-12 mt-2"
                >
                  <label>Curso</label>
                  <select
                    v-model="fastSecretariaContratoNovo.id_secretaria_curso"
                    class="form-control"
                  >
                    <option
                      value="0"
                      selected
                    >
                      Todos os cursos
                    </option>
                    <option
                      v-for="curso in fastSecretariaCursos"
                      :key="curso.id_secretaria_curso"
                      :value="curso.id_secretaria_curso"
                    >
                      {{ curso.nome_curso }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-12 mt-2">
                  <label>Template do contrato</label>
                  <div class="alert alert-info">
                    <small
                      class="m-0 font-weight-bold text-secondary"
                    >Você pode usar as seguintes palavras especiais no seu texto:</small>
                    <table>
                      <tbody>
                        <tr>
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%nome_aluno%</span> - nome do aluno
                            </small>
                          </td>  
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%cpf_aluno%</span> - CPF do aluno
                            </small>
                          </td>  
                        </tr>
                        <tr>
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%logradouro_aluno%</span> - Endereço do aluno
                            </small>
                          </td>    
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%numero_aluno%</span> - Número do endereço do aluno
                            </small>
                          </td>     
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%bairro_aluno%</span> - Bairro do aluno
                            </small>
                          </td> 
                        </tr>
                        <tr>
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%cep_aluno%</span> - CEP do aluno
                            </small>
                          </td>    
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%cidade_aluno%</span> - Cidade do aluno
                            </small>
                          </td>     
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%uf_aluno%</span> - Estado do aluno
                            </small>
                          </td> 
                        </tr>
                        <tr>
                          <td class="pr-4" colspan="3">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%complemento_aluno%</span> - Dado completar do endereço do aluno
                            </small>
                          </td>   
                        </tr>
                      </tbody>
                    </table>
                    <table>
                      <tbody>
                        <tr>
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%nome_responsavel%</span> - nome do responsavel
                            </small>
                          </td>  
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%cpf_responsavel%</span> - CPF do responsavel
                            </small>
                          </td>  
                        </tr>
                        <tr>
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%logradouro_responsavel%</span> - Endereço do responsavel
                            </small>
                          </td>    
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%numero_responsavel%</span> - Número do endereço do responsavel
                            </small>
                          </td>     
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%bairro_responsavel%</span> - Bairro do responsavel
                            </small>
                          </td> 
                        </tr>
                        <tr>
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%cep_responsavel%</span> - CEP do responsavel
                            </small>
                          </td>    
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%cidade_responsavel%</span> - Cidade do responsavel
                            </small>
                          </td>     
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%uf_responsavel%</span> - Estado do responsavel
                            </small>
                          </td> 
                        </tr>
                        <tr>
                          <td class="pr-4" colspan="3">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%complemento_responsavel%</span> - Dado completar do endereço do responsável
                            </small>
                          </td>   
                        </tr>
                      </tbody>
                    </table>
                    <table>
                      <tbody>
                        <tr>
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%valor_total%</span> - Valor total do contrato (valor da matrícula + valor do curso)
                            </small>
                          </td>                            
                        </tr>
                        <tr>
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%numero_parcelas%</span> - Número de parcelas definido no pagamento
                            </small>
                          </td> 
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%valor_parcela%</span> - Valor da parcela definido no pagamento
                            </small>
                          </td>  
                        </tr>
                        <tr>
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%valor_matricula%</span> - Valor da matrícula
                            </small>
                          </td>  
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%valor_total_curso%</span> - Valor total do curso
                            </small>
                          </td>
                        </tr>
                        <tr>
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%dia_parcela%</span> - Dia da parcela
                            </small>
                          </td>
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%mes_primeira_parcela%</span> - Mês da primeira parcela
                            </small>
                          </td>
                             
                        </tr>
                        <tr>
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%ano_primeira_parcela%</span> - Ano da primeira parcela
                            </small>
                          </td> 
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="mb-2 text-right">
                    <button
                    class="btn btn-sm btn-primary"
                    @click="exibeModalEditarHTML('novo')"
                  >
                    <b-icon-code-slash /> Editar HTML
                  </button>
                  </div>
                  <quill-editor
                    v-model="fastSecretariaContratoNovo.html_template"
                    :options="editorOption"
                  />
                </div>
                <div class="col-12 mt-4">
                  <div class="form-group mb-0">
                    <button
                      href="#"
                      type="button"
                      class="btn btn-primary"
                      @click="criarSecretariaContrato()"
                    >
                      Criar contrato
                    </button>
                    <button
                      class="btn btn-sm btn-primary ml-4"
                      @click="visualizaPdfContratoNovo()"
                    >
                      <i class="far fa-eye" /> Visualizar contrato
                    </button>
                    <button
                      v-if="fastSecretariaContratoNovo.exibir || fastSecretariaContratoEditar.exibir"
                      class="btn btn-sm btn-secondary ml-4"
                      @click="getSecretariaContratos($route.params.id_plataforma)"
                    >
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
              <!-- Editar contrato -->
              <div
                v-show="fastSecretariaContratoEditar.exibir"
                class="row"
              >
                <div class="col-sm-12 col-md-12 col-lg-12 mt-4 mb-4 text-center">
                  <h3>Editar contrato</h3>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-12 mt-2">
                  <label>Nome do contrato</label>
                  <input
                    v-model="fastSecretariaContratoEditar.nome_contrato"
                    type="text"
                    class="form-control"
                    maxlength="30"
                  >
                </div>
                <div class="col-sm-12 col-md-12 col-lg-12 mt-2">
                  <label>Tipo de contrato</label>
                  <select
                    v-model="fastSecretariaContratoEditar.tipo_contrato"
                    class="form-control"
                  >
                    <option value="C">
                      Curso
                    </option>
                  </select>
                </div>
                <div
                  v-if="fastSecretariaContratoEditar.tipo_contrato == 'C'"
                  class="col-sm-12 col-md-12 col-lg-12 mt-2"
                >
                  <label>Curso</label>
                  <select
                    v-model="fastSecretariaContratoEditar.id_secretaria_curso"
                    class="form-control"
                  >
                    <option
                      value="0"
                      selected
                    >
                      Todos os cursos
                    </option>
                    <option
                      v-for="curso in fastSecretariaCursos"
                      :key="curso.id_secretaria_curso"
                      :value="curso.id_secretaria_curso"
                    >
                      {{ curso.nome_curso }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-12 mt-2">
                  <label>Template do contrato</label>
                  <div class="alert alert-info">
                    <small
                      class="m-0 font-weight-bold text-secondary"
                    >Você pode usar as seguintes palavras especiais no seu texto:</small>
                    <table>
                      <tbody>
                        <tr>
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%nome_aluno%</span> - nome do aluno
                            </small>
                          </td>  
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%cpf_aluno%</span> - CPF do aluno
                            </small>
                          </td>  
                        </tr>
                        <tr>
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%logradouro_aluno%</span> - Endereço do aluno
                            </small>
                          </td>    
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%numero_aluno%</span> - Número do endereço do aluno
                            </small>
                          </td>     
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%bairro_aluno%</span> - Bairro do aluno
                            </small>
                          </td> 
                        </tr>
                        <tr>
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%cep_aluno%</span> - CEP do aluno
                            </small>
                          </td>    
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%cidade_aluno%</span> - Cidade do aluno
                            </small>
                          </td>     
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%uf_aluno%</span> - Estado do aluno
                            </small>
                          </td> 
                        </tr>
                        <tr>
                          <td class="pr-4" colspan="3">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%complemento_aluno%</span> - Dado completar do endereço do aluno
                            </small>
                          </td>   
                        </tr>
                      </tbody>
                    </table>
                    <table>
                      <tbody>
                        <tr>
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%nome_responsavel%</span> - nome do responsavel
                            </small>
                          </td>  
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%cpf_responsavel%</span> - CPF do responsavel
                            </small>
                          </td>  
                        </tr>
                        <tr>
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%logradouro_responsavel%</span> - Endereço do responsavel
                            </small>
                          </td>    
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%numero_responsavel%</span> - Número do endereço do responsavel
                            </small>
                          </td>     
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%bairro_responsavel%</span> - Bairro do responsavel
                            </small>
                          </td> 
                        </tr>
                        <tr>
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%cep_responsavel%</span> - CEP do responsavel
                            </small>
                          </td>    
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%cidade_responsavel%</span> - Cidade do responsavel
                            </small>
                          </td>     
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%uf_responsavel%</span> - Estado do responsavel
                            </small>
                          </td> 
                        </tr>
                        <tr>
                          <td class="pr-4" colspan="3">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%complemento_responsavel%</span> - Dado completar do endereço do responsável
                            </small>
                          </td>   
                        </tr>
                      </tbody>
                    </table>
                    <table>
                      <tbody>
                        <tr>
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%valor_total%</span> - Valor total do contrato (valor da matrícula + valor do curso)
                            </small>
                          </td>                            
                        </tr>
                        <tr>
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%numero_parcelas%</span> - Número de parcelas definido no pagamento
                            </small>
                          </td> 
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%valor_parcela%</span> - Valor da parcela definido no pagamento
                            </small>
                          </td>  
                        </tr>
                        <tr>
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%valor_matricula%</span> - Valor da matrícula
                            </small>
                          </td>  
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%valor_total_curso%</span> - Valor total do curso
                            </small>
                          </td>
                        </tr>
                        <tr>
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%dia_parcela%</span> - Dia da parcela
                            </small>
                          </td> 
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%mes_primeira_parcela%</span> - Mês da primeira parcela
                            </small>
                          </td>
                        </tr>
                        <tr>
                          <td class="pr-4">
                            <small class="m-0 text-secondary">
                              <span class="font-weight-bold">%ano_primeira_parcela%</span> - Ano da primeira parcela
                            </small>
                          </td> 
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <quill-editor
                    v-model="fastSecretariaContratoEditar.html_template"
                    :options="editorOption"
                  />
                </div>
                <div class="col-12 mt-4">
                  <div class="form-group mb-0">
                    <button
                      href="#"
                      type="button"
                      class="btn btn-primary"
                      @click="editarContrato()"
                    >
                      Atualizar contrato
                    </button>
                    <button
                      class="btn btn-sm btn-primary ml-4"
                      @click="visualizaPdfContratoEditar()"
                    >
                      <i class="far fa-eye" /> Visualizar contrato
                    </button>
                    <button
                      v-if="fastSecretariaContratoNovo.exibir || fastSecretariaContratoEditar.exibir"
                      class="btn btn-sm btn-secondary ml-4"
                      @click="getSecretariaContratos($route.params.id_plataforma)"
                    >
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
              <!-- fd-app-meus-cursos -->
              <div class="mt-5 mb-5">
                <a
                  v-if="getUrlParameter('tesouraria')"
                  class="btn btn-red-hollow"
                  :href="
                    '/plataforma/' +
                      $route.params.id_plataforma +
                      '/tesouraria'
                  "
                  @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/tesouraria')"
                ><b-icon-arrow-return-left />
                  Voltar para menu</a>
                <a
                  v-else
                  class="btn btn-red-hollow"
                  :href="
                    '/plataforma/' +
                      $route.params.id_plataforma +
                      '/secretaria'
                  "
                  @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/secretaria')"
                >
                  <b-icon-arrow-return-left />
                  Voltar para menu</a>                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modals -->
    
    <modal
      name="modalExcluirContrato"
      :scrollable="true"
      height="auto"
      :shift-y="0.1"
      :focus-trap="true"
      :adaptive="true"
    >
      <div class="row p-4">
        <div class="col-6 pl-4 pr-4">
          <h4>Excluir contrato?</h4>
        </div>
        <div class="col-6 pl-4 pr-4 text-right">
          <a
            class="btn btn-secondary"
            href="#"
            @click.prevent="hideModal('modalExcluirContrato')"
          >
            <b-icon-arrow-return-left />
          </a>
        </div>
        <div class="col-12 p-4">
          <div class="row">
            <div class="col-12">
              <div class="form-group mb-0">
                <button
                  href="#"
                  type="button"
                  class="btn btn-danger"
                  @click.prevent="excluirContrato()"
                >
                  Confirmar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>

    <modal
      name="modalEditarHTMLNovo"
      :width="modalWidthMd"
      :shift-y="0.1"
      height="auto"
      :scrollable="true"
      :adaptative="true"
    >
      <div class="row p-4">
        <div class="col-8 pl-4 pr-4">
          <h4>Editar HTML do email</h4>
        </div>
        <div class="col-4 pl-4 pr-4 text-right">
          <a
            class="btn btn-secondary"
            href="#"
            @click.prevent="
              hideModal('modalEditarHTMLNovo')
            "
          >
            <b-icon-arrow-return-left />
          </a>
        </div>
        <div class="col-12 pt-4 pr-4 pb-0 pl-4">
          <textarea
            v-model="fastSecretariaContratoNovo.html_template"
            class="form-control"
            rows="10"
          />
        </div>
        <div class="col-12 pt-4 pr-4 pb-0 pl-4">
          <button
            class="btn btn-secondary mt-2 ml-2"
            @click.prevent="
              hideModal('modalEditarHTMLNovo')
            "
          >
            Voltar
          </button>
        </div>
      </div>
    </modal>

    <VueHtml2pdf
      ref="html2PdfNovo"
      class="mx-auto"
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :html-to-pdf-options="htmlToPdfOptions"
      pdf-content-width="960px"
      :manual-pagination="false"
      :paginate-elements-by-height="10000"
    >
      <section slot="pdf-content">
        <div
          class="fast-pdf-html-template"
          v-html="fastSecretariaContratoNovo.html_template"
        />
      </section>
    </VueHtml2pdf>

    <VueHtml2pdf
      ref="html2PdfEditar"
      class="mx-auto"
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :html-to-pdf-options="htmlToPdfOptions"
      pdf-content-width="955px"
      :manual-pagination="false"
      :paginate-elements-by-height="5000"
    >
      <section slot="pdf-content">
        <div
          class="fast-pdf-html-template"
          v-html="fastSecretariaContratoEditar.html_template"
        />       
      </section>
    </VueHtml2pdf>

    <notifications
      group="foo"
      :close-on-click="false"
      position="bottom right"
    />
  </div>
</template>

<script>
import { settings } from "@/config";
import methods from "@/methods";
import VueHtml2pdf from "vue-html2pdf"; //https://www.npmjs.com/package/vue-html2pdf
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  name: "HomeInternoSecretariaContratos",
  components: { quillEditor, VueHtml2pdf },
  mixins: [methods],
  data: function () {
    return {
      modalWidthSm: this.isMobile() ? "80%" : "30%",
      modalWidthMd: this.isMobile() ? "90%" : "50%",
      modalWidthLg: this.isMobile() ? "100%" : "90%",
      // Documento
      contrato_html_template: '<p class="ql-align-center"><strong>CONTRATO DE PRESTAÇÃO DE SERVIÇOS EDUCACIONAIS</strong></p><p class="ql-align-justify"><br></p><p class="ql-align-justify"><strong>CONTRATANTE:</strong>&nbsp;%nome_responsavel%, portador do CPF nº %cpf_responsavel%, residente e domiciliado na %logradouro_responsavel%, nº %numero_responsavel%, bairro %bairro_responsavel%, CEP %cep_responsavel%, %cidade_responsavel%, %uf_responsavel%;</p><p class="ql-align-justify"><br></p><p class="ql-align-justify"><strong>ALUNO: </strong>%nome_aluno%, portador do CPF nº %cpf_aluno%, residente e domiciliado na %logradouro_aluno%, nº %numero_aluno%, bairro %bairro_aluno%, CEP %cep_aluno%, %cidade_aluno%, %uf_aluno%;</p><p class="ql-align-justify"><br></p><p class="ql-align-justify"><strong style="color: rgb(51, 51, 51);">CONTRATADA: CONSULTORIA EM INFORMATICA E SERVIÇOS EDUCACIONAIS CONCURSEIRO SOCIEDADE EMPRESARIAL LTDA - CONCURSEIRO, sobre O CNPJ 32.221.157/0001-33, endereço Rua Carlos Gomes, 222 – Oitavo Andar, Bairro Boa Vista, Porto Alegre – RS, CEP 90.480-000.</strong></p><p class="ql-align-justify"><strong style="color: rgb(51, 51, 51);">PARCEIRO CONTRATADO: CURSO PREPARATÓRIO ALFA O PRINCÍPIO LTDA, sobre o CNPJ </strong><strong>11.310.799/0001-39</strong><strong style="color: rgb(51, 51, 51);">, endereço Rua São Paulo, 416, segundo andar, Centro - Divinópolis/MG - CEP: </strong><strong style="color: rgb(0, 0, 0);">35500-006</strong><strong style="color: rgb(51, 51, 51);">.</strong></p><p class="ql-align-justify"><strong style="background-color: transparent;">As partes acima acordam com o presente Contrato de Prestação de Serviços Educacionais, representadas neste instrumento como </strong><strong>CONTRATANTE, CONTRATADA E PARCEIRO CONTRATADO,</strong> que se regerá pelas cláusulas seguintes:</p><p class="ql-align-center"><br></p><p class="ql-align-justify"><strong>Cláusula PRIMEIRA</strong>&nbsp;<strong>– OBJETO</strong></p><p class="ql-align-justify"><strong>1.&nbsp;&nbsp;&nbsp;&nbsp;O Objeto do presente instrumento é a prestação de serviços educacionais, pela CONTRATADA, sendo os mesmos prestados na Escola PARCEIRO CONTRATADO, para o CURSO EJA ENSINO MÉDIO, para o ano letivo de 2021 em favor do CONTRATANTE.</strong></p><p><strong>2.&nbsp;&nbsp;&nbsp;&nbsp;Disponibilização: Será disponibilizada plataforma de ensino a distância, contendo carga horária de 330 horas que compreendem 110 horas (Primeiro ano), 110 horas (Segundo Ano) e 110 horas (Terceiro ano), distribuídas em 13 disciplinas. Cada aula contendo 01 (uma) vídeo aula de 8 a 12 minutos, documento (pdf ou ppt) com o conteúdo da aula e 05 exercícios sobre o tema abordado. Ao final de cada Ano (Primeiro, segundo e terceiro) será aplicada, por disciplina, avaliação que equivale a 4 pontos e ao final do curso a avaliação final que equivale 6 pontos. Será disponibilizada também 180 horas de aulas ao vivo com carga horária de 20 horas mensais, que o aluno pode acompanhar em qualquer computador, celular ou tablet ou em uma sala dos polos autorizados da CONTRATADA.</strong></p><p>3.&nbsp;&nbsp;&nbsp;&nbsp;Garantia da Certificação do CONTRATANTE: Para garantir a certificação do contratante, será considerado APROVADO o aluno que tirar média final 5, que dar-se-á somando a média simples das duas avaliações por disciplina.</p><p>4.&nbsp;&nbsp;&nbsp;&nbsp;Certificado: Será fornecido por escola parceira homologada nacional na plataforma da CONTRATADA e credenciada em secretaria estaduais e MEC (Ministério da Educação Brasileiro), válido em todo território nacional.</p><p class="ql-align-justify">5.&nbsp;&nbsp;&nbsp;&nbsp;Recuperação: Considera o contratante como em RECUPERAÇÃO, quando a soma das duas médias não alcançar a média 5, para isso será aplicada uma segunda prova de recuperação.</p><p class="ql-align-justify"><br></p><p><strong>Cláusula SEGUNDA</strong>&nbsp;<strong>– OBRIGAÇÕES DA CONTRATADA</strong></p><p class="ql-align-justify">1.&nbsp;&nbsp;&nbsp;&nbsp;Fornecer plataforma tecnológica com acesso individual por aluno, que seja acessível em celular, tablet, notebook, computador de mesa ou televisor ligado a um computador.</p><p>2.&nbsp;&nbsp;&nbsp;&nbsp;Fornecer suporte ao usuário em primeiro nível pelo PARCEIRO CONTRATADO e suporte em terceiro nível pela CONTRATADA.</p><p class="ql-align-justify">3.&nbsp;&nbsp;&nbsp;&nbsp;Fornecer as avaliações em modo on-line.</p><p class="ql-align-justify"><br></p><p><strong>Cláusula TERCEIRA</strong>&nbsp;<strong>– OBRIGAÇÕES DO PARCEIRO CONTRATADA</strong></p><p class="ql-align-justify">1.&nbsp;&nbsp;&nbsp;&nbsp;Fornecer avaliações em modo presencial.</p><p class="ql-align-justify">2.&nbsp;&nbsp;&nbsp;&nbsp;Garantir instalações, seguras, confortáveis, climatizadas, recursos digitais para estudos, presenciais e on-line.</p><p class="ql-align-justify"><strong>3.&nbsp;&nbsp;&nbsp;&nbsp;Fornecer suporte ao usuário em primeiro nível.</strong></p><p class="ql-align-justify"><br></p><p><strong>Cláusula QUARTA</strong>&nbsp;<strong>– PAGAMENTO</strong></p><p class="ql-align-justify">1.&nbsp;&nbsp;&nbsp;&nbsp;Em virtude da prestação de serviços educacionais o CONTRATANTE pagará à contratada o valor total de %valor_total%, que se divide em %valor_matricula% no valor da matrícula e %valor_total_curso% no valor de todo o curso do ensino médio.</p><p class="ql-align-justify">2.&nbsp;&nbsp;&nbsp;&nbsp;O Curso será dividido em %numero_parcelas% parcelas de %valor_parcela% + %valor_matricula% do valor da matrícula e será pago juntamente com a primeira parcela.</p><p class="ql-align-justify"><strong>3.&nbsp;&nbsp;&nbsp;&nbsp;Para garantir o recebimento do Certificado o CONTRATANTE terá que ter quitado todo o curso.</strong></p><p class="ql-align-justify"><br></p><p><strong>Cláusula QUINTA</strong>&nbsp;<strong>– INADIMPLENTES</strong></p><p class="ql-align-justify">1.&nbsp;&nbsp;&nbsp;&nbsp;Caso o CONTRATANTE não pague a mensalidade dentro do prazo estabelecido, arcará com uma multa de 2% do valor da parcela, mais juros de 1% ao mês.</p><p>2.&nbsp;&nbsp;&nbsp;&nbsp;Caso o CONTRATANTE atrase o pagamento em até 03 dias os acessos serão congelados até a quitação da(s) parcela(s) em aberto.</p><p class="ql-align-justify">3.&nbsp;&nbsp;&nbsp;&nbsp;Caso o responsável financeiro do CONTRATANTE, não quite as parcelas em aberto por mais de 60 dias o CONTRATADO registrara o valor total do contrato subtraído o que já foi pago, nos órgão de proteção ao crédito SPC/SERASA.</p><p class="ql-align-justify"><br></p><p class="ql-align-justify"><br></p><p class="ql-align-justify"><strong>Cláusula SEXTA</strong>&nbsp;<strong>– RESCISÃO</strong></p><p class="ql-align-justify"><strong>1.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;O Presente instrumento poderá ser rescindido por qualquer das partes com a necessidade de comunicação formal do CONTRATANTE para a CONTRATADA através de requerimento de cancelamento da matrícula, devendo todas as parcelas estarem quitadas até o dia da rescisão e o pagamento da taxa de cancelamento de R$ 200 (duzentos) reais.</strong></p><p><strong>2.&nbsp;&nbsp;&nbsp;&nbsp;Caso o CONTRATANTE atrase o pagamento em até 03 dias os acessos serão congelados até a quitação da(s) parcela(s) em aberto.</strong></p><p>3.&nbsp;&nbsp;&nbsp;&nbsp;A CONTRADA poderá rescindir o contrato, após deliberação interna, por indisciplina do aluno representado neste contrato, e por inadimplência do CONTRANTE, o qual será previamente avisado do débito e da possível rescisão.<strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong></p><p><br></p><p><strong>Cláusula SÉTIMA</strong>&nbsp;<strong>– DO PRAZO</strong></p><p class="ql-align-justify">1.&nbsp;&nbsp;&nbsp;&nbsp;O Presente contrato terá validade de 9 (nove) meses, iniciando-se na data de registro (pagamento) da mátricula, e terminando 09 (nove) meses depois.</p><p class="ql-align-justify"><br></p><p><strong>Cláusula OITAVA</strong>&nbsp;<strong>– CONDIÇÕES GERAIS</strong></p><p class="ql-align-justify">1.&nbsp;&nbsp;&nbsp;&nbsp;A validade deste instrumento está condicionada à realização da matrícula do aluno.</p><p class="ql-align-justify">2.&nbsp;&nbsp;&nbsp;&nbsp;A não frequência do aluno nas aulas ou utilização da plataforma digital, não influi na obrigatoriedade do pagamento das mensalidades.</p><p class="ql-align-justify">3.&nbsp;&nbsp;&nbsp;&nbsp;A Contratada não se obriga a fornecer qualquer material didático que será de inteira responsabilidade do CONTRATANTE.</p><p class="ql-align-justify"><br></p><p class="ql-align-justify"><strong>Cláusula NONA</strong>&nbsp;<strong>– DO FORO</strong></p><p class="ql-align-justify"><strong>1.&nbsp;&nbsp;&nbsp;&nbsp;Para dirimir quaisquer controvérsias oriundas do CONTRATO, as partes elegem o foro da comarca de PORTO ALEGRE.</strong></p><p class="ql-align-justify"><strong>2.&nbsp;&nbsp;&nbsp;&nbsp;Por estarem assim justos e contratados, firmam o presente instrumento, em duas vias de igual teor, juntamente com duas testemunhas.</strong></p><p><br></p><p><br></p><p>Local e data:</p><p><br></p><p><strong style="background-color: transparent;">__________________________&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;_______________________</strong></p><p><strong style="background-color: transparent;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;CONTRATANTE&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;CONTRATADO</strong></p><p><br></p><p><strong style="background-color: transparent;">Testemunhas:</strong></p><p><strong style="background-color: transparent;">_________________________&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong></p><p><strong style="background-color: transparent;">NOME</strong></p><p><strong style="background-color: transparent;">RG</strong></p><p><strong style="background-color: transparent;">_________________________</strong></p><p><strong style="background-color: transparent;">NOME</strong></p><p><strong style="background-color: transparent;">RG</strong></p><p class="ql-align-center"><br></p><p class="ql-align-justify"><br></p><p class="ql-align-justify"><br></p>',
      fastSecretariaContratos: [],
      fastSecretariaContratosLoading: true,
      fastSecretariaContratoNovo: {
        id_contrato: 0,
        nome_contrato: "",
        tipo_contrato: "C",
        html_template: "",
        url_contrato: "",
        id_secretaria_curso: "0",
        id_plataforma: 0,
        exibir: false
      },
      fastSecretariaContratoEditar: {
        id_contrato: 0,
        nome_contrato: "",
        tipo_contrato: "",
        html_template: "",
        url_contrato: "",
        id_secretaria_curso: 0,
        id_plataforma: 0,
        exibir: false
      },
      fastSecretariaCursos: [],
      // Editor de texto
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], // toggled buttons
            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: "ordered" }, { list: "bullet" }, { align: [] }, "image"],
          ],
        },
      },
      // pdf
      htmlToPdfOptions: {
        margin: 0.5,
        filename: 'Contrato.pdf',
        image: {
            type: 'jpeg',
            quality: 1
        },
        enableLinks: false,
        html2canvas: {
            scale: 1,
            scrollX: 0,
            scrollY: 0,
            useCORS: true,
            width: 960,
        },
        jsPDF: {
            unit: 'in',
            format: 'a4',
            orientation: 'portrait'
        }
        
      }
    };
  },
  mounted: function () {
    if (this.$route.params.id_plataforma) {
      this.getFastDependecias(this.$route.params.id_plataforma, 'secretario')
        .then(() => {
          if (this.$store.state.fastPlataformaModulos.modulo_secretaria) {
            this.getSecretariaContratos(this.$route.params.id_plataforma);
            this.getSecretariaCursos(this.$route.params.id_plataforma);
            this.$store.state.fastCarregando = false;
          } else {
            this.$store.state.fastCarregando = false;
            this.exibeToasty("Módulo não disponível para sua plataforma", "error");
          }          
        })
        .catch((e) => {
          this.exibeToasty(e, "error");
          this.$store.state.fastCarregando = false;
        });
    } else {
      this.$store.state.fastCarregando = false;
      this.exibeToasty("Você não possui permissões", "error");
    }
  },
  methods: {
    getSecretariaContratos(id_plataforma){    
      this.fastSecretariaContratosLoading = true  
      this.fastSecretariaContratoNovo.exibir = false
      this.fastSecretariaContratoEditar.exibir = false
      this.fastSecretariaContratoNovo.html_template = this.contrato_html_template
      this.promiseGetFastApi("api/fast_secretaria_contrato/lista", "id_plataforma=" + id_plataforma).then(obj => {
        console.log("getSecretariaContratos", obj);
        if (obj.length) this.fastSecretariaContratos = obj;
        this.fastSecretariaContratosLoading = false
      }).catch(e => {
        console.log(e);
        this.fastSecretariaContratosLoading = false
      })
    },
    async criarSecretariaContrato() {
      this.fastSecretariaContratoNovo.id_plataforma = this.$route.params.id_plataforma;
      if (!this.fastSecretariaContratoNovo.url_contrato) this.fastSecretariaContratoNovo.url_contrato = null
      this.promiseInserirFastApi(this.fastSecretariaContratoNovo, "fast_secretaria_contrato").then((res) => {
        console.log("criarSecretariaContrato", res)
        this.exibeToasty("Contrato criado com sucesso", "success");
        this.fastSecretariaContratoNovo = {
          id_contrato: 0,
          nome_contrato: "",
          tipo_contrato: "C",
          html_template: this.contrato_html_template,
          url_contrato: "",
          id_secretaria_curso: "0",
          id_plataforma: 0,
          exibir: false
        }
        this.fastSecretariaContratos = res;
      }).catch((e) => {
        this.exibeToasty("Erro ao criar requisito", "error");
      });
    },
    exibeModalEditarContrato(contrato) {
      contrato.exibir = true;
      if (!contrato.id_secretaria_curso) contrato.id_secretaria_curso = 0
      this.fastSecretariaContratoEditar = contrato;
    },
    async editarContrato() {
       this.$store.state.fastCarregando = true;
        this.promiseAtualizarFastApi(this.fastSecretariaContratoEditar, "fast_secretaria_contrato").then(e => {
          this.exibeToasty("Salvo com sucesso", "success");
          this.$store.state.fastCarregando = false;
          this.fastSecretariaContratoEditar = {
            id_contrato: 0,
            nome_contrato: "",
            tipo_contrato: "",
            html_template: "",
            url_contrato: "",
            id_secretaria_curso: 0,
            id_plataforma: 0,
            exibir: false
          }
        }).catch(e => {
          this.exibeToasty("Erro ao salvar alterações", "error");
          this.$store.state.fastCarregando = false;
        }
        );
    },
    exibeModalExcluirContrato(contrato) {
      this.fastSecretariaContratoEditar = contrato;
      this.showModal("modalExcluirContrato");
    },
    async excluirContrato(){
      this.promiseExcluirFastApi(this.fastSecretariaContratoEditar, "fast_secretaria_contrato").then(e => {
        this.exibeToasty("Contrato excluído com sucesso", "success");        
        this.fastSecretariaContratos = e; 
        this.hideModal("modalExcluirContrato");        
      }).catch(e => {
        this.exibeToasty("Erro ao excluir", "error");
        this.$store.state.fastCarregando = false;
      });
    },
    // Cursos
    getSecretariaCursos(id_plataforma){
      this.promiseGetFastApi("api/fast_secretaria_curso/lista", "id_plataforma=" + id_plataforma + "&id_secretaria_curso=0").then(obj => {
        console.log("getSecretariaCursos", obj);
        this.$store.state.fastCarregando = false;
        if (obj.length)  {          
          this.fastSecretariaCursos = obj;
        }
        else {
          this.fastSecretariaCursos = [];
        }
          
      }).catch(e => {
        console.log(e);
      })
    },
    exibirListaContratos() {
      //this.fastSecretariaContratoEditar.exibir = false;
      //this.fastSecretariaContratoNovo.exibir = false;      
      location.reload();
    },
    visualizaPdfContratoNovo() { 
      this.$refs.html2PdfNovo.generatePdf();
    },
    visualizaPdfContratoEditar() {
      this.$refs.html2PdfEditar.generatePdf();
    },
    // Editar html
    exibeModalEditarHTML(tipo){
      if (tipo == 'novo') {
        this.showModal('modalEditarHTMLNovo')
      }
    }
  },
};
</script>

<style scope>
.fast-pdf-html-template *{
  margin: 0 !important;
}
.blink_me {
  animation: destacaBotao 500ms alternate infinite ease-in;
}

@keyframes destacaBotao {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.1);
  }
}
.tabs-component {
  margin: 1em 0;
}

.tabs-component-tabs {
  border: solid 1px #ddd;
  border-radius: 6px;
  margin-bottom: 5px;
}

@media (min-width: 992px) {
  .tabs-component-tabs {
    border: 0;
    align-items: stretch;
    display: flex;
    justify-content: flex-start;
    margin-bottom: -1px;
  }
}

.tabs-component-tab {
  color: #999;
  font-size: 14px;
  font-weight: 600;
  margin-right: 0;
  list-style: none;
}

.tabs-component-tab:hover {
  color: #666;
}

.tabs-component-tab.is-active {
  color: #000;
}

.tabs-component-tab.is-disabled * {
  color: #cdcdcd;
  cursor: not-allowed !important;
}

@media (min-width: 992px) {
  .tabs-component-tab {
    background-color: #fff;
    border: solid 1px #ddd;
    border-radius: 3px 3px 0 0;
    margin-right: 0.5em;
    transform: translateY(0px);
    transition: transform 0.3s ease;
  }

  .tabs-component-tab.is-active {
    border-bottom: solid 1px #fff;
    z-index: 2;
    transform: translateY(0);
  }
}

.tabs-component-tab-a {
  align-items: center;
  color: inherit;
  display: flex;
  padding: 0.75em 1em;
  text-decoration: none;
}

.tabs-component-panels {
  padding: 4em 0;
}

@media (min-width: 992px) {
  .tabs-component-panels {
    border-top-left-radius: 0;
    background-color: #fff;
    border: solid 1px #ddd;
    border-radius: 0 6px 6px 6px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
    padding: 2em;
  }
}
.prefix,
.suffix {
  align-items: center;
  border-radius: 1.25rem;
  display: flex;
  font-size: 0.75rem;
  flex-shrink: 0;
  height: 1.25rem;
  justify-content: center;
  line-height: 1.25rem;
  min-width: 1.25rem;
  padding: 0 0.1em;
}

.prefix {
  background-color: #d1e8eb;
  color: #0c5174;
  margin-right: 0.35em;
}

.suffix {
  background-color: #c03;
  color: #fff;
  margin-left: 0.35em;
}
/* Ajuste para gerador de pdf */
.vue-html2pdf p {
  margin: 0 !important;
  padding: 0 !important;  
}
.ql-align-center {
  text-align: center;
}
.ql-align-justify {
  text-align: justify;
}

/* Ajustes de conflito no editor de texto */
/* CSS do fastead faz editor Quill ficar bugada para edição */
[contenteditable="true"] {
  display: block;
}
/* CSS do fastead faz imagem ficar 100% sempre */
[contenteditable="true"] img {
  width: auto;
}
.fd-app-curso-aulas .fd-app-curso-aulas-list .fd-app-curso-aulas-list-item,
.fd-app-meus-cursos .fd-app-curso-aulas-list .fd-app-curso-aulas-list-item {
  font-family: initial;
}

.ql-container {
  height: auto !important;
}

@media (min-width: 992px) {
  .suffix {
    position: absolute;
    right: -0.6em;
    top: -0.725em;
  }
}
</style>
